import React from 'react';
import './css/AboutUs.css';
import pictureOne from './assets/picOne.png';
import headerBg from './assets/picOne.png'; // Reuse or replace with relevant header image

const AboutMBS = () => {
    return (
        <div className="about-us">
            {/* === Header Section with Overlay === */}
            <section
                className="about-header"
                style={{
                    backgroundImage: `url(${headerBg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "45vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div className="overlay">
                    <h1 className="page-title">ABOUT US</h1>
                    <p className="subtitle">
                        The Malawi Bureau of Standards (MBS) promotes metrology, standardization, and quality assurance to ensure safety, reliability, and excellence in Malawi's industries.
                    </p>
                </div>
            </section>

{/* === Background and Mandate Section === */}
<section className="background-mandate">
                <div className="left-card">
                    <div className="background-row">
                        <h3 className="theme-color-text">BACKGROUND</h3>
                        <p>
                            The Malawi Bureau of Standards (MBS) is a statutory organization established in 1972 by an Act of Parliament (Cap 51:02) of the Laws of Malawi, amended as Act No 14 of 2012.
                        </p>
                        <p>
                            The MBS is governed by a Board of Directors, appointed by the Government, responsible for managing its operations.
                        </p>
                        <p>
                            The Director General is the Chief Executive Officer, overseeing day-to-day administration within the broad guidelines of the MBS Board.
                        </p>
                    </div>
                    <div className="mandate-row">
                        <h3 className="theme-color-text">MANDATE</h3>
                        <p>
                            To promote metrology, standardization, and quality assurance of commodities, as well as the manufacture, production, processing, or treatment thereof; and to provide for matters incidental to, or connected with standardization.
                        </p>
                    </div>
                </div>
                <div className="right-card">
                    <img src={pictureOne} alt="Mandate Illustration" />
                </div>
            </section>


            {/* === Mission and Vision Section === */}
            <section className="mission-vision">
                <div className="mission">
                    <center>
                        <h3 className="theme-color-text">MISSION</h3>
                    </center>
                    <p style={{color: "rgba(0,0,0,0.8)"}}>
                        To contribute, by promoting quality and standardization towards the strengthening of Malawi's economy and enhancing the quality of life of its people.
                    </p>
                </div>
                <div className="vision">
                    <center>
                        <h3 className="theme-color-text">VISION</h3>
                    </center>
                    <p style={{color: "rgba(0,0,0,0.8)"}}>
                        To be leaders in the region in providing standards information, quality management and assurance, metrology services, and training.
                    </p>
                </div>
            </section>

            {/* === Primary Objective Section === */}
            <section className="primary-objective">
                <span className="line"></span>
                <h2 className="theme-color-text">PRIMARY OBJECTIVE</h2>
                <span className="line"></span>
                <br />
                <p>Promoting Standardization And Quality Assurance In Malawi</p>
            </section>

            

            {/* === Inline CSS for Overlay and Header === */}
            <style>{`
                 .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
                .page-title {
                    font-size: 2.2rem;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .subtitle {
                    font-size: 1rem;
                    margin-top: 5px;
                    font-weight: 500;
                }
                .about-us p {
                    margin: 0;
                    font-size: 1rem;
                }
            `}</style>
        </div>
    );
};

export default AboutMBS;
